import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("kl_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  const tenant = getTenantSlug();
  if (tenant) config.headers["X-Tenant"] = tenant;
  return config;
});

// Dentro un iframe (anteprime/landing): il focus automatico non deve far scorrere la pagina che ci ospita
try {
  if (window.self !== window.top) {
    const origFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (opts) { return origFocus.call(this, { ...(opts || {}), preventScroll: true }); };
  }
} catch { /* ignore */ }

// Handoff sessione dalla landing piattaforma verso un dominio proprio del club: #sso=<token>
try {
  const m = /[#&]sso=([^&]+)/.exec(window.location.hash || "");
  if (m) { localStorage.setItem("kl_token", decodeURIComponent(m[1])); window.history.replaceState(null, "", window.location.pathname + window.location.search); }
} catch { /* ignore */ }

// Origine visita (es. ?src=vetrina dalla vetrina piattaforma): memorizzata per attribuire le card nate dalla vetrina.
try {
  const src = new URLSearchParams(window.location.search).get("src");
  if (src) localStorage.setItem("kl_src", src.toLowerCase().slice(0, 30));
} catch { /* ignore */ }
export const getVisitSource = () => { try { return localStorage.getItem("kl_src") || null; } catch { return null; } };

// Multi-tenant: slug da ?t= nell'URL (memorizzato) oppure da localStorage; in produzione basta il dominio del club.
export function getTenantSlug() {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get("t");
    if (fromUrl) { localStorage.setItem("kl_tenant", fromUrl.toLowerCase()); return fromUrl.toLowerCase(); }
    return localStorage.getItem("kl_tenant") || "";
  } catch { return ""; }
}
export function setTenantSlug(slug) {
  if (slug) localStorage.setItem("kl_tenant", slug); else localStorage.removeItem("kl_tenant");
}

// Applica X-Tenant anche alle chiamate axios "nude" e alle fetch() verso il backend (portale pubblico PWA).
axios.interceptors.request.use((config) => {
  const tenant = getTenantSlug();
  if (tenant && (config.url || "").startsWith(BACKEND_URL)) config.headers["X-Tenant"] = tenant;
  return config;
});
if (typeof window !== "undefined" && !window.__klFetchPatched) {
  window.__klFetchPatched = true;
  const _fetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = typeof input === "string" ? input : input?.url || "";
    const tenant = getTenantSlug();
    if (tenant && url.startsWith(BACKEND_URL)) {
      const headers = new Headers(init.headers || (typeof input !== "string" ? input.headers : undefined) || {});
      headers.set("X-Tenant", tenant);
      init = { ...init, headers };
    }
    return _fetch(input, init);
  };
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Errore imprevisto";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;
